import type {EditableField, RecordEditation} from 'src/typings';
import type {PromiseBasedRecordEditationDataService, RecordEditationAction,} from '../types';
import type {Observable} from 'rxjs';
import {from} from 'rxjs';
import {GenericEditationAction} from './generic-editation-action';

export class MoveFieldDownAction extends GenericEditationAction implements RecordEditationAction {
    constructor(private backend: PromiseBasedRecordEditationDataService, private field: EditableField) {
        super('MoveFieldDownAction');
    }

    public executeAction(editationObject: RecordEditation): Observable<RecordEditation> {
        return from(this.backend.moveField(editationObject.id, this.field.id, true));
    }
}